import { articles } from '@/mocks/articles';

export default function CommunityStats() {
  const totalReads = articles.reduce((sum, a) => sum + a.readCount, 0);
  const totalComments = articles.reduce((sum, a) => sum + a.commentCount, 0);
  const totalLikes = articles.reduce((sum, a) => sum + a.likeCount, 0);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-2xl p-8 md:p-12 text-center text-white">
          <h2 className="text-2xl md:text-3xl font-heading font-bold mb-4">
            加入草榴技术讨论区
          </h2>
          <p className="text-white/80 text-sm md:text-base max-w-[550px] mx-auto mb-8">
            与数万名技术爱好者一起，分享经验、碰撞思想、共同成长
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div>
              <div className="text-3xl md:text-4xl font-bold mb-1">12,580+</div>
              <div className="text-xs text-white/70">技术文章</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold mb-1">68,420+</div>
              <div className="text-xs text-white/70">社区成员</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold mb-1">{totalComments.toLocaleString()}+</div>
              <div className="text-xs text-white/70">讨论交流</div>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold mb-1">{totalLikes.toLocaleString()}+</div>
              <div className="text-xs text-white/70">互动点赞</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}